import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { captureAttribution } from "./attribution.js";
import { Survey } from "./Survey.js";

// Runs on every landing visit, regardless of whether the survey mounts.
captureAttribution();

const mount = document.getElementById("fsl-survey-root");
if (mount) {
  createRoot(mount).render(
    <StrictMode>
      <Survey />
    </StrictMode>,
  );
} else if (import.meta.env.DEV) {
  // eslint-disable-next-line no-console
  console.warn("[fsl] #fsl-survey-root not found in the DOM; survey not mounted.");
}
